import { Text } from 'onefaceui-react-components';
import styled from 'styled-components';

export const Container = styled.div`
  [data-testid="filter-builder"] {
    box-shadow: none;
  }
`;
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
`;
export const Title = styled(Text).attrs({
  size: 'md',
  weight: 'bold'
})`
  color: var(--grey-900);
`;

export const Description = styled(Text).attrs({
  size: 'xs',
  weight: 'regular'
})`
  color: var(--grey-400) !important;
`;

export const TableContainer = styled.div`
  height: 400px;
`;
